<template lang="html">
  <div class="">
    <ServiceSubheader />
    <p>Reports</p>
    <TipManagementReportsComponent />
  </div>
</template>

<script>
import ServiceSubheader from '../../components/ServiceComponents/ServiceSubheader';
import TipManagementReportsComponent from '../../components/ServiceComponents/TipManagementReportsComponent';
export default {
  name: "TipManagementReportsPage",
  components: {
    ServiceSubheader,
    TipManagementReportsComponent
  }
}
</script>

<style lang="css" scoped>
div p{
  color: rgb(60, 3, 140);
  font-size: 36px;
  font-weight: bold;
}
</style>
